<template>
    <div>
        <div class="seaContent flx jsb">
            <div class="seaLeft">
                <div class="searchInp flx alc">
                    <div class="inp">
                        <input type="text" v-model="keyword" placeholder="请输入搜索关键词" />
                    </div>
                    <div class="searchBtn cursor" @click="getList">
                        搜索
                    </div>
                </div>
                <div class="searchResults">
                    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal"
                        @select="handleSelect">
                        <el-menu-item index="1">活动报名</el-menu-item>
                        <el-submenu index="2">
                            <template slot="title">在线学习</template>
                            <el-menu-item index="2-1">精品回放</el-menu-item>
                            <el-menu-item index="2-2">在线学习</el-menu-item>
                        </el-submenu>
                        <el-menu-item index="3">求职招聘</el-menu-item>
                        <el-menu-item index="4">导师陪跑</el-menu-item>
                        <el-menu-item index="5">职业认证</el-menu-item>
                        <el-menu-item index="6">学历提升</el-menu-item>
                        <el-menu-item index="7">图书推荐</el-menu-item>
                        <el-menu-item index="8">服务采购</el-menu-item>
                    </el-menu>
                    <Activity :keyword="keyword" :list="list" :type='activeIndex' v-if="activeIndex != 3 && activeIndex != 7"></Activity>
                    <job :keyword="keyword" :type="activeIndex" :list="list" v-if="activeIndex == 3"></job>
                    <book :keyword="keyword" :type="activeIndex" :list="list" v-if="activeIndex == 7"></book>
                  <!--  <coach :keyword="keyword" :type="activeIndex" :list="list" v-if="activeIndex == 4"></coach> -->
                    <el-pagination layout="prev, pager, next" :page-size="30" :current-page="page"
                        @current-change="pageChange" :hide-on-single-page="true" :total="totals">
                    </el-pagination>
                </div>
            </div>
            <div class="seaRight">

            </div>
        </div>
    </div>
</template>

<script>
    import Activity from "@/components/search/activity.vue"
    import job from "@/components/search/job.vue"
    import book from "@/components/search/book.vue"
    // import coach from "@/components/search/coach.vue"
    import {
        getActiviesList,
        getLiveList,
        getZylist,
        getEduList,
        getServiceLists,
        getRecruList,
        getBookList,
        getCoachList
    } from "@/api/index.js"
    export default {
        name: "search",
        components: {
            Activity,
            job,
            book,
            // coach
        },
        data() {
            return {
                activeIndex: '1',
                keyword: "",
                list: [],
                page: 1,
                totals: 0
            };
        },
        created() {},
        methods: {
            getList() {
                let that = this
                let data = {}
                data.page = that.page
                data.size = 50
                data.keywords = that.keyword
                if (that.activeIndex == 1) {
                    data.source = 'search'
                    getActiviesList(data).then((res) => {
                        if (res.code == 1) {
                            that.list = res.data.list.data
                            that.totals = res.data.total
                        } else if (res.code == -1) {
                            that.list = []
                            that.$message.error(res.msg)
                        }
                    })
                } else if (that.activeIndex == "2-1") {
                    data.is_type = 2
                    getLiveList(data).then((res) => {
                        that.list = res.data.data
                        that.totals = res.data.total
                    })
                } else if (that.activeIndex == "2-2") {
                    data.is_type = 1
                    getLiveList(data).then((res) => {
                        that.list = res.data.data
                        that.totals = res.data.total
                    })
                } else if (that.activeIndex == 5) {
                    if (that.keyword == '') {
                        return
                    }
                    getZylist(data).then((res) => {
                        if (res.code == 1) {
                            that.list = res.data.data
                            that.totals = res.data.total
                        }
                    })
                } else if (that.activeIndex == 6) {
                    if (that.keyword == '') {
                        return
                    }
                    getEduList(data).then((res) => {
                        if (res.code == 1) {
                            that.list = res.data.data
                            that.totals = res.data.total
                        }
                    })
                } else if (that.activeIndex == 8) {
                    if (that.keyword == '') {
                        return
                    } else {
                        getServiceLists(data).then((res) => {
                            if (res.code == 1) {
                                that.list = res.data.data
                                that.totals = res.data.total
                            }
                        })
                    }
                }else if (that.activeIndex == 3) {
                    if (that.keyword == '') {
                        return
                    } else {
                        getRecruList(data).then((res) => {
                            if (res.code == 1) {
                                that.list = res.data.data
                                that.totals = res.data.total
                            }
                        })
                    }
                }else if (that.activeIndex == 7) {
                    if (that.keyword == '') {
                        return
                    } else {
                        getBookList(data).then((res) => {
                            if (res.code == 1) {
                                that.list = res.data.data
                                that.totals = res.data.total
                            }
                        })
                    }
                } else if (that.activeIndex == 4) {
                    if (that.keyword == '') {
                        return
                    } else {
                        getCoachList(data).then((res) => {
                            if (res.code == 1) {
                                that.list = res.data.data
                                that.totals = res.data.total
                            }
                        })
                    }
                } 
                
                
            },
            pageChange() {
                this.getList()
            },
            handleSelect(key, keyPath) {
                console.log(key, keyPath);
                this.list = []
                this.page = 1
                this.activeIndex = key
                this.getList()
            }
        }
    };
</script>

<style scoped>
    .el-menu--horizontal>.el-menu-item.is-active {
        border-bottom: 2px solid #409EFF !important;
        color: #303133;
    }

    .inp {
        flex: 1;
    }

    .searchInp {
        width: 100%;
        margin-bottom: 20px;
    }

    .seaLeft {
        width: 100%;

    }

    .seaContent {
        width: 1460px;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 20px 0;
    }

    .searchResults {
        width: 100%;
        background: #fff;
        min-height: 50vh;
    }
</style>